var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tes-td',{attrs:{"props":_vm.props}},[_c('item-step-by-icon',{attrs:{"step":_vm.props.value,"status":_vm.props.row.status}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }